/* Sofia's Spot: Bundle and save (built 25 Oct 2026). Jessie, 25 Oct: $5 off, "bundles only", "stack" with the welcome code,
   and on the product page just the words "Bundle and save" (the $5 shows in the cart).
   An order gets $5 off when it holds a bundle piece AND the piece that bundle started from, two or more pieces in all.
   A bundle piece is one added from a gift bundle (the scripted rows), a curated gift bundle, a gift box, the cart's own add
   offers, or the other colour reached from the colour circles: every one of those carries the _bundle_* stamps, and its
   _bundle_anchor names the piece it started from. The anchor must still be in the cart, so a colour circle used only to move
   to the other colour, or a picked piece left behind when its main piece is taken out, does not count. A piece that is the
   page's own product (its anchor) does not count by itself. Cards never count. Shopify's own discounts cannot tell a bundle
   piece from the same piece bought on its own, so this file switches the hidden code BUNDLEANDSAVE ($5 off, two items or
   more, combines with other discounts) on when the cart qualifies and off when it no longer does. It runs on every page,
   from cart-mini.liquid, because the cart can change anywhere.
   A shopper's own code always wins: if ours does not apply, or it stops one of their codes applying (a code that cannot be
   combined with ours, such as a welcome code made before 25 Oct), ours comes off again and stays off while those codes are on
   the cart. Switching the discount off in Shopify also stops it (it then never applies, so it is taken off the same way).
   Free shipping: Shopify works out "free over $99" after discounts, and about 1 curated gift bundle in 5 costs $99 to
   $103.99. When Bundle and save would take an order from $99 or more to under $99, the site also adds BUNDLESHIP (free
   standard shipping up to $10, made 25 Oct 2026 on Jessie's yes, only for this). If BUNDLESHIP does not apply (switched
   off, or a piece in the cart ships on its own rate: tags ship:bulky, ship:large, ship:pickup), the $5 is held back
   instead, so nobody pays $10 shipping to save $5.
   Speed (Jessie, 11:56am: "Slight delay in cart drawer for $5 off to appear"): the product page calls prime() as it adds
   picks, so the code is on before the drawer draws; everywhere else the drawer's redraw is checked 150 ms after it settles.
   The drawer and the cart page show the saving as "Bundle and save (-$5.00)". */
(function () {
  if (window.__sofiaBundleSave) return; window.__sofiaBundleSave = true;
  var CODE = 'BUNDLEANDSAVE', SHIP = 'BUNDLESHIP', FREE_AT = 9900, AMOUNT = 500, BLOCK = 'sofiaBundleSaveBlock';
  var Q = window.sofiaCartQueue = window.sofiaCartQueue || (function () {
    var tail = Promise.resolve();
    return function (task) { var run = tail.then(task, task); tail = run.catch(function () {}); return run; };
  })();
  var last = null, busy = false, again = false, mem = {}, tagCache = {};
  function up(s) { return String(s || '').toUpperCase(); }
  function cfg() { var el = document.getElementById('cart-config'); try { return JSON.parse((el && el.textContent) || '{}'); } catch (e) { return {}; } }
  function isCard(it) { return !!it.gift_card || /card/i.test(String(it.product_type || '')); }
  function anchorOf(it) {
    var p = it.properties || {};
    return (p._bundle_row && up(p._bundle_row) !== 'CARD') ? String(p._bundle_anchor || '') : '';
  }
  function ours(c) { var u = up(c); return u === CODE || u === SHIP; }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (d) { return String(d.code); }); }
  function same(a, b) { return a.map(up).sort().join(',') === b.map(up).sort().join(','); }
  function keyOf(codes) { return 'c:' + codes.map(up).sort().join(','); }
  /* a block is remembered for this tab: k (ours did not apply with these codes) or k + '|ship' (BUNDLESHIP did not) */
  function blocked(k) {
    if (mem[k]) return true;
    try { return (sessionStorage.getItem(BLOCK) || '').split('\n').indexOf(k) >= 0; } catch (e) { return false; }
  }
  function block(k) {
    mem[k] = true;
    try { var l = (sessionStorage.getItem(BLOCK) || '').split('\n').filter(Boolean); if (l.indexOf(k) < 0) l.push(k); sessionStorage.setItem(BLOCK, l.slice(-12).join('\n')); } catch (e) {}
  }
  function oursOff(cart) {
    /* what our own code takes off the order right now (0 when it is not applied) */
    var n = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (up(d.title) === CODE || up(d.key) === CODE) n += d.total_allocated_amount || 0;
    });
    return n;
  }
  function wanted(cart) {
    var units = 0, extra = false, inCart = {}, items = cart.items || [];
    items.forEach(function (it) { if (!isCard(it)) inCart[it.handle] = true; });
    items.forEach(function (it) {
      if (isCard(it)) return;
      units += it.quantity;
      var a = anchorOf(it);
      if (a && a !== it.handle && inCart[a]) extra = true;
    });
    /* the order without our $5: after the free card and after any code of the shopper's, before shipping */
    var before = (cart.total_price || 0) + oursOff(cart);
    var on = extra && units >= 2;
    return { code: on, band: on && before >= FREE_AT && before - AMOUNT < FREE_AT, ship: false };
  }
  function tagsOf(handle) {
    if (!tagCache[handle]) {
      tagCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
        .then(function (j) { return (j.tags || []).map(function (t) { return String(t).toLowerCase(); }); })
        .catch(function () { delete tagCache[handle]; return ['ship:unknown']; });
    }
    return tagCache[handle];
  }
  function ownRate(cart) {
    /* true when a piece ships on its own rate or cannot ship, so "free over $99" never covered it */
    var hs = [];
    (cart.items || []).forEach(function (it) { if (!isCard(it) && hs.indexOf(it.handle) < 0) hs.push(it.handle); });
    return Promise.all(hs.map(tagsOf)).then(function (all) {
      return all.some(function (tags) { return tags.some(function (t) { return /^ship:(bulky|large|pickup|unknown)$/.test(t); }); });
    });
  }

  function relabel() {
    document.querySelectorAll('.discounts .sale-color').forEach(function (s) {
      if (s.getAttribute('data-sp-done')) return;
      var t = s.textContent || '';
      var u = up(t).replace(/^\s+/, '');
      if (u.indexOf(SHIP) === 0) { s.textContent = 'Free shipping on your bundle'; s.setAttribute('data-sp-done', '1'); return; }
      if (u.indexOf(CODE) !== 0) return;
      var m = t.match(/\(\s*-?\s*([^)]+)\)/);
      s.textContent = 'Bundle and save (-' + (m ? m[1].trim() : '$5.00') + ')';
      s.setAttribute('data-sp-done', '1');
    });
    if (!(last && (last.discount_codes || []).some(function (d) { return up(d.code) === SHIP && d.applicable; }))) return;
    document.querySelectorAll('.js-ajax-cart-content .shipping .a-right').forEach(function (el) {
      if (el.getAttribute('data-sp-done')) return; el.textContent = 'Free'; el.setAttribute('data-sp-done', '1');
    });
    document.querySelectorAll('.js-ajax-cart-content .js-cart-shipping-countdown').forEach(function (el) {
      if (el.getAttribute('data-sp-done')) return;
      var ps = el.querySelectorAll('p'); if (ps[0]) ps[0].textContent = 'Your order ships free.';
      for (var i = 1; i < ps.length; i++) ps[i].style.display = 'none';
      var fill = el.querySelector('.cart-shipping-progress__fill'); if (fill) fill.style.width = '100%';
      el.setAttribute('data-sp-done', '1');
    });
  }
  function redraw(cart) {
    var T = window.Shopify && Shopify.theme;
    if (T && T.ajaxCart && T.ajaxCart.updateView) { try { T.ajaxCart.updateView(cfg(), cart); } catch (e) {} }
    else if (document.body && document.body.classList.contains('template-cart')) { location.reload(); return; }
    setTimeout(relabel, 60);
  }
  function setCodes(list) {
    return Q(function () {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    });
  }
  function plan(cart, others, k) {
    var w = wanted(cart);
    /* ours is on the cart but Shopify is not applying it (a code of the shopper's won, or the discount is switched off) */
    var dead = (cart.discount_codes || []).some(function (d) { return up(d.code) === CODE && !d.applicable; });
    if (w.code && dead) block(k);
    if (w.code && blocked(k)) return Promise.resolve({ code: false, band: false, ship: false });
    if (!w.code || !w.band) return Promise.resolve(w);
    if (blocked(k + '|ship')) return Promise.resolve({ code: false, band: true, ship: false });
    return ownRate(cart).then(function (own) { return own ? { code: false, band: true, ship: false } : { code: true, band: true, ship: true }; });
  }
  function sync() {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    var cart, have, others, k;
    return Q(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (c) {
        cart = c; last = c; have = codesOf(c); others = have.filter(function (x) { return !ours(x); }); k = keyOf(others);
        return plan(c, others, k);
      })
      .then(function (w) {
        var want = others.slice();
        if (w.code) want.push(CODE);
        if (w.ship) want.push(SHIP);
        if (same(have, want)) { relabel(); return null; }
        var was = {};
        (cart.discount_codes || []).forEach(function (d) { if (d.applicable) was[up(d.code)] = true; });
        return setCodes(want).then(function (c2) {
          last = c2;
          if (w.code) {
            var got = {}, lost = false;
            (c2.discount_codes || []).forEach(function (d) {
              var u = up(d.code);
              if (d.applicable) got[u] = true; else if (!ours(u) && was[u]) lost = true;
            });
            if (!got[CODE] || lost || (w.ship && !got[SHIP])) {
              /* ours did not apply, it pushed out a code of the shopper's, or the free shipping half did not apply:
                 theirs stays, ours comes off and stays off for this cart's codes */
              block((!got[CODE] || lost) ? k : k + '|ship');
              return setCodes(others).then(function (c3) { last = c3; redraw(c3); });
            }
          }
          redraw(c2);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; setTimeout(sync, 60); } });
  }
  /* Called by the product page (sofia-pick.js) right after the picks are queued and before the page's own piece goes in:
     puts our code on the cart in the same queue, so the drawer opens with the saving already on it. Both requests run
     inside one queued task, so nothing else can slip between them. sync() checks the result once the drawer redraws.
     It steps aside when a shopper's code is on the cart or ours was refused in this tab. */
  function prime() {
    return Q(function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var have = codesOf(c);
        if (have.some(function (x) { return !ours(x); }) || blocked(keyOf([])) || have.map(up).indexOf(CODE) >= 0) return null;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: have.concat([CODE]).join(',') }) })
          .then(function (r) { return r.ok ? r.json() : null; }).then(function (c2) { if (c2) last = c2; return null; });
      });
    }).catch(function () { return null; });
  }
  window.sofiaBundleSave = { sync: sync, prime: prime };

  function boot() {
    if ('MutationObserver' in window) {
      document.querySelectorAll('.js-ajax-cart-content').forEach(function (t) {
        var ts = null;
        /* relabel at once (an observer runs before the browser paints, so the code's own name never shows) */
        new MutationObserver(function () {
          relabel();
          clearTimeout(ts); ts = setTimeout(sync, 150);
        }).observe(t, { childList: true, subtree: true });
      });
    }
    relabel();
    sync();
    window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
